/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.99"
        height="14.52"
        viewBox="0 0 18.99 14.52"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M2.64 14.5h16.35V2.64h-1.92V0H0v12.34h2.64Zm15.35-1H3.64v-1.18h14.35Zm0-2.18H3.64v-1.18h14.35Zm0-7.7v5.52H3.64V3.62Zm-17 7.7V1h15.07v1.64H2.64v8.7ZM8.4 4.79H4.55v3.18H8.4Zm-1 2.18H5.55V5.79H7.4Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'TwoCreditCardsIcon';

export default Icon;
